import icon from 'vue-svgicon';

icon.register({
    'light/trophy': {
        width: 16,
        height: 16,
        viewBox: '-293 385 24 24',
        data: `<path pid="0" d="M-273.2 394.4c3.5-.7 3.7-5.2 3.7-7.2 0-.3-.2-.5-.5-.5h-.2l-2.3.8M-288.8 394.4c-3.5-.7-3.7-5.2-3.7-7.2 0-.3.2-.5.5-.5h.2l2.3.8" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M-272.5 391v-5c0-.3-.2-.5-.5-.5h-16c-.3 0-.5.2-.5.5v5c0 3.9 2.6 7.2 6.3 8.2.4.1.7.5.7.9.1 1.8-.2 3.6-1 5.2-.3.7-1 1.2-1.8 1.2h-1.2c-.6 0-1 .4-1 1s.4 1 1 1h11c.6 0 1-.4 1-1s-.4-1-1-1h-1.2c-.8 0-1.5-.5-1.8-1.2-.7-1.6-1-3.4-1-5.2 0-.4.3-.8.7-.9 3.7-1 6.3-4.4 6.3-8.2zM-285.3 406.5h8.6" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round"/>`,
    },
});
